import { render, staticRenderFns } from "./Group_User.vue?vue&type=template&id=71962cf6&"
import script from "./Group_User.vue?vue&type=script&lang=js&"
export * from "./Group_User.vue?vue&type=script&lang=js&"
import style0 from "./Group_User.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports